/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import React, { useState, useMemo, useEffect } from 'react';
import { Modal } from 'antd';
import { css } from 'emotion';
import moment from 'moment';

interface WatchFileUpdateRecordButtonProps {
  historyFiles: any[];
}

export default function WatchFileUpdateRecordButton(props: WatchFileUpdateRecordButtonProps) {
  const { historyFiles } = props;
  const [visible, setVisible] = useState(false);

  const recordList = useMemo(() => {
    return (historyFiles || []).sort((a, b) => b.relationTime - a.relationTime);
  }, [historyFiles]);

  const onWatchRecord = () => {
    setVisible(true);
  };

  const handleCancel = (e?: React.MouseEvent<HTMLElement>) => {
    e?.stopPropagation();
    setVisible(false);
  };

  const renderFileSize = (size: number) => {
    return size > 1024 * 1024
      ? `${(size / 1024 / 1024).toFixed(1)}M`
      : `${(size / 1024).toFixed(1)}K`;
  };

  if (!historyFiles?.length) {
    return null;
  }

  return (
    <div className={buttonCss} onClick={(e) => e.stopPropagation()}>
      <div
        className={updateButtonCss}
        onClick={(e) => {
          e.stopPropagation();
          onWatchRecord();
        }}
      >
        更新记录
      </div>
      <Modal
        destroyOnClose
        title={
          <div className={titleCss}>
            更新记录
            <span className={tipsCss}>
              （仅用于查看文件更新记录。如需下载最新版本文件，请关闭弹窗后点击文件的下载按钮）
            </span>
          </div>
        }
        width={800}
        visible={visible}
        centered
        bodyStyle={{ maxHeight: '502px', overflowY: 'auto' }}
        okButtonProps={{
          style: {
            display: 'none',
          },
        }}
        cancelText="关闭"
        onCancel={handleCancel}
        maskClosable={true}
        className={modalCss}
      >
        <div onClick={(e) => e.stopPropagation()}>
          {recordList.map((t) => (
            <div key={t.id} className={recordItemCss}>
              <span className="recordTime">
                {moment(t.relationTime).format('YYYY-MM-DD HH:mm')}
              </span>
              {t.originalFileId !== t.fileId ? (
                <span className="recordContent">
                  更新为<span className="recordContentFileName">{t.fileName}</span> (
                  {renderFileSize(t.size)})
                </span>
              ) : (
                <span className="recordContent">
                  <span className="recordContentFileName">{t.fileName}</span> (
                  {renderFileSize(t.size)})
                </span>
              )}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}

const buttonCss = css`
  position: relative;
`;

const updateButtonCss = css`
  color: #1890ff;
  cursor: pointer;
  user-select: none;
  cursor: pointer;
`;

const tipsCss = css`
  color: #999;
  font-size: 12px;
`;

const recordItemCss = css`
  display: flex;
  align-items: flex-start;
  gap: 46px;

  .recordTime {
    font-size: 14px;
    color: #444;
  }

  .recordContent {
    font-size: 12px;
    color: #999;
    flex: 1;
  }

  .recordContentFileName {
    font-size: 14px;
    color: #444;
    margin-right: 10px;
  }
`;

const modalCss = css`
  .ant-modal-header {
    background: #fff;
  }
`;

const titleCss = css`
  color: #333;
`;
